import { ref } from 'vue'

const isOpen = ref(false)

/** Shared open state for removing linked emails or cards from the dashboard. */
export function useDeleteLinkedAccountModal() {
  const openDeleteLinkedAccountModal = () => {
    isOpen.value = true
  }

  const closeDeleteLinkedAccountModal = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    openDeleteLinkedAccountModal,
    closeDeleteLinkedAccountModal,
  }
}
